import { IFetchCustomerByIdDTO } from 'modules/customer/domain/dtos';
import { ICustomersRepository } from 'shared/domain/repositories';

export class FetchCustomerByIdUseCase {
  constructor(private customersRepository: ICustomersRepository) {}

  public async execute({ id }: IFetchCustomerByIdDTO) {
    return this.customersRepository.findById(id);
  }
}
